export const ACTION_LABELS: Record<string, { label: string; color: string }> = {
  login: { label: 'Login', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-300' },
  password_change: { label: 'Password Change', color: 'bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-300' },
  report_create: { label: 'Created', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300' },
  report_update: { label: 'Updated', color: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/50 dark:text-indigo-300' },
  report_delete: { label: 'Deleted', color: 'bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-300' },
  match_view: { label: 'Viewed', color: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200' },
};

export const ROLE_COLORS: Record<string, string> = {
  admin: 'bg-indigo-100 text-indigo-700 ring-indigo-600/20 dark:bg-indigo-900/50 dark:text-indigo-300 dark:ring-indigo-400/20',
  manager: 'bg-purple-100 text-purple-700 ring-purple-600/20 dark:bg-purple-900/50 dark:text-purple-300 dark:ring-purple-400/20',
  coach: 'bg-blue-100 text-blue-700 ring-blue-600/20 dark:bg-blue-900/50 dark:text-blue-300 dark:ring-blue-400/20',
  scout: 'bg-emerald-100 text-emerald-700 ring-emerald-600/20 dark:bg-emerald-900/50 dark:text-emerald-300 dark:ring-emerald-400/20',
  medical: 'bg-amber-100 text-amber-700 ring-amber-600/20 dark:bg-amber-900/50 dark:text-amber-300 dark:ring-amber-400/20',
};

// Dashboard "view as" roles (admin only) — relocated here from the nav bar.
export const ROLE_VIEWS: { value: string; label: string; description: string; tile: string }[] = [
  { value: 'manager', label: 'Manager', description: 'Squad, fixtures & overall management', tile: 'bg-purple-500' },
  { value: 'coach', label: 'Coach', description: 'Training, tactics & match prep', tile: 'bg-blue-500' },
  { value: 'scout', label: 'Scout', description: 'Player scouting & reports', tile: 'bg-emerald-500' },
  { value: 'medical', label: 'Medical', description: 'Injuries & player availability', tile: 'bg-amber-500' },
];

// Deterministic tile colour per workspace so each is visually distinct.
export const WORKSPACE_TILE_COLORS = [
  'bg-rose-500',
  'bg-sky-500',
  'bg-emerald-500',
  'bg-violet-500',
  'bg-amber-500',
  'bg-teal-500',
  'bg-fuchsia-500',
  'bg-indigo-500',
];

export function workspaceTileColor(key: string): string {
  let hash = 0;
  for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return WORKSPACE_TILE_COLORS[hash % WORKSPACE_TILE_COLORS.length];
}

export function passwordStrength(pw: string): { score: number; label: string; color: string } {
  if (!pw) return { score: 0, label: '', color: '' };
  let score = 0;
  if (pw.length >= 6) score++;
  if (pw.length >= 10) score++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  const buckets = [
    { label: 'Weak', color: 'bg-red-500' },
    { label: 'Weak', color: 'bg-red-500' },
    { label: 'Fair', color: 'bg-amber-500' },
    { label: 'Good', color: 'bg-yellow-500' },
    { label: 'Strong', color: 'bg-emerald-500' },
    { label: 'Strong', color: 'bg-emerald-500' },
  ];
  return { score, ...buckets[score] };
}
